module.exports = __webpack_public_path__ + "img/p1-desc@2x.c45f19e1.jpg";